import { ManPower } from "../Components/index.js";

export default [
    {
        path: "/report/parade-state-man-power",
        component: ManPower,
        name: "report-parade-state-man-power",
        meta: {
            requiresAuth: true,
        },
    },
];
